export default {
    // 获取系统数据
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 获取用户数据
    QueryUserList(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/queryAlarmUserSendConfig', params, response);
    },
    // 获取用户数据
    QueryUserList1(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/queryAlarmUserSendConfig1', params, response);
    },
    saveUserAlarmSendConfig(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/saveUserAlarmSendConfig', params, response);
    },
    saveRoleAlarmSendConfig(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/saveRoleAlarmSendConfig', params, response);
    },
    delUserSortConfig(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/delAlarmSendConfig', params, response);
    },
    queryTreeList(params, response) {
        window.vue.$apiAxios.postRequestBody('/staffManager/queryStaffOrgTree', params, response);
    },
    querySortList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleAuthList', params, response);
    },
    // 获取角色数据
    QueryRoleList(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/queryAlarmRoleSendConfig', params, response);
    }
};
